import React from "react";
import OnlineLoadBooking from "../../components/service-pages/online-load-booking/OnlineLoadBooking";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";
import { FaqsResponse } from "@vahak/core/dist/_services/faq.service";
import {
    getOnlineLoadBookingPageLayout,
    getOnlineLoadBookingStaticProps
} from "../../components/service-pages/constants/onlineLoadBooking-constants-methods";

export default function OnlineLoadBookingPage({ faqs }: { faqs: FaqsResponse[] }) {
    return <OnlineLoadBooking faqs={faqs} />;
}

OnlineLoadBookingPage.getLayout = getOnlineLoadBookingPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await getOnlineLoadBookingStaticProps()),
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("servicePages")))
        }
    };
}
